module.exports = __webpack_public_path__ + "static/img/biobank-3.5fd3867cfb89ba52fb20021cae8242bf.png";